import React from 'react'
import { TodayView } from './TodayView'

export const Dashboard: React.FC = () => {
  return <TodayView />
}
